"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M4 6.5A1.5 1.5 0 0 1 5.5 5h13A1.5 1.5 0 0 1 20 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5zM12 9a2 2 0 1 0-4 0 2 2 0 0 0 4 0m2 2a.5.5 0 0 0-.41.213l-2.237 3.197-1.472-1.734a.5.5 0 0 0-.76-.001l-3 3.5a.5.5 0 1 0 .759.65l2.618-3.055 1.262 1.486-.67.957a.5.5 0 1 0 .82.574L14 12.372l3.09 4.415a.5.5 0 1 0 .82-.574l-3.5-5A.5.5 0 0 0 14 11"
  })]
}), 'ImageBlankFilled');
//# sourceMappingURL=index.js.map